"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotHourGlass = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotHourGlass = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.4",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M32.562 36.385c2.014-2.938 1.484-7.56.954-13.088-.53-5.53-1.06-11.966-4.4-14.263-3.366-2.298-9.515-.455-14.497 2.484-4.983 2.964-8.773 6.998-8.614 10.71.159 3.713 4.24 7.052 7.448 10.284 3.207 3.232 5.565 6.303 9.01 7.211 3.473.882 8.058-.373 10.099-3.338Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M9 3.001 31 3M9 3.001H5m4 0S9.97 9.704 12.174 14c.627 1.22 1.352 2.247 2.184 2.87.873.674 1.43 1.166 1.772 1.63.35.476.473.924.473 1.509 0 1.147-.416 1.715-2.127 3.1-.076.062-.076.062-.098.082C10.598 26.024 9 37 9 37M31 3l4 .001M31 3s-.961 6.686-3.148 11c-.632 1.247-1.367 2.297-2.21 2.928-.836.646-1.383 1.125-1.728 1.572-.385.499-.517.958-.517 1.567 0 1.155.477 1.773 2.225 3.124C29.402 26.024 31 37 31 37m0 0H9m22 0h4m-4 0s-8-10.5-11-10.5S9 37 9 37m0 0H5"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotHourGlass = SpotHourGlass;
SpotHourGlass.displayName = "SpotHourGlass";